import { Component } from '@angular/core';

@Component({
  selector: 'text-divider',
  templateUrl: './text-divider.component.html',
  styleUrls: ['./text-divider.component.scss'],
})
export class TextDividerComponent extends Component {}
